import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { AuthenticationStore, useAuthentication } from '@freelancelabs/components';

import ProtectedRoute from '../app/components/ProtectedRoute';
import PrivateLayout from '../app/content/PrivateLayout';
import { PrivateRoutes, PublicRoutes } from '../constants';
import ActivationPage from './Activation';
import CguPage from './Cgu';
import EmailSentPage from './EmailSent';
import LoginPage from './Login';
import LoginCheckPage from './LoginCheck';
import LoginPasswordLessPage from './LoginPasswordLess';
import ResetPasswordPage from './ResetPassword';
import UpdatePasswordPage from './UpdatePassword';
import AccountPage from './private/Account';
import RedirectMiddlewarePage from './private/RedirectMiddleware';

const Pages = () => {
    const { hasSession } = useAuthentication() as AuthenticationStore;
    return (
        <BrowserRouter>
            <Routes>
                <Route path={PublicRoutes.CGU} element={<CguPage />} />
                <Route
                    element={
                        <ProtectedRoute isAllowed={!hasSession} redirectPath={PrivateRoutes.REDIRECT_MIDDLEWARE} />
                    }
                >
                    <Route path={PublicRoutes.LOGIN} element={<LoginPage />} />
                    <Route path={PublicRoutes.LOGIN_PASSWORD_LESS} element={<LoginPasswordLessPage />} />
                    <Route path={PublicRoutes.LOGIN_CHECK} element={<LoginCheckPage />} />
                    <Route path={PublicRoutes.RESET_PASSWORD} element={<ResetPasswordPage />} />
                    <Route path={PublicRoutes.UPDATE_PASSWORD} element={<UpdatePasswordPage />} />
                    <Route path={PublicRoutes.EMAIL_SENT} element={<EmailSentPage />} />
                    {/* Inside the « no session » group like the other public screens:
                        somebody already signed in has, by definition, already
                        consumed their invitation: the API sends no second link to
                        an active person. They are sent to the application rather
                        than to a form that could only refuse them. */}
                    <Route path={PublicRoutes.ACTIVATION} element={<ActivationPage />} />
                </Route>
                <Route element={<ProtectedRoute isAllowed={hasSession} redirectPath={PublicRoutes.LOGIN} />}>
                    {/* Attention, `RedirectMiddleware` RESTE HORS DE LA COQUILLE, et c'est ce
                        qui la rend juste : cette page est un passage, elle fait accepter les
                        CGU puis dresse la barrière du MFA. Un rail y proposerait « Mon
                        profil » à quelqu'un qui n'a pas franchi une condition d'entrée, et la
                        barrière cesserait d'en être une : on en sortirait par le menu. */}
                    <Route path={PrivateRoutes.HOMEPAGE} element={<RedirectMiddlewarePage />} />
                    <Route path={PrivateRoutes.REDIRECT_MIDDLEWARE} element={<RedirectMiddlewarePage />} />
                    <Route element={<PrivateLayout />}>
                        <Route path={PrivateRoutes.ACCOUNT} element={<AccountPage />} />
                        <Route
                            path={PrivateRoutes.SECURITY}
                            element={<Navigate to={PrivateRoutes.ACCOUNT} replace />}
                        />
                    </Route>
                </Route>
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </BrowserRouter>
    );
};

export default Pages;
